import { FC, Fragment } from "react";
import { Redeem } from "@mui/icons-material";
import { useAccount, useWalletClient } from "wagmi";
import { createPublicClient, createWalletClient, custom, http } from "viem";

import { ListAction, ListActionVariant } from "@framework/styled";
import { type AddressType, type IPonziDeposit, PonziDepositStatus } from "@framework/types";
import { useMetamask } from "@dzambalaorg/react-hooks-eth";
import ReceiveRewardABI from "@framework/abis/json/Staking/receiveReward.json";

import { DepositRewardDialog, IDepositRewardDto } from "../../../../dialogs/reward-dialog";

export interface IPonziRewardComplexButtonProps {
  className?: string;
  disabled?: boolean;
  stake: IPonziDeposit;
  variant?: ListActionVariant;
}

export const PonziRewardComplexButton: FC<IPonziRewardComplexButtonProps> = props => {
  const { className, disabled, stake, variant } = props;

  // const [isRewardDialogOpen, setIsRewardDialogOpen] = useState(false);

  const { address, connector } = useAccount();
  const { data: client } = useWalletClient();

  const { execute: _metaFn } = useMetamask(async (stake: IPonziDeposit, values: IDepositRewardDto) => {
    const provider = await connector!.getProvider();

    const publicClient = createPublicClient({
      chain: client!.chain,
      transport: http(client!.chain.rpcUrls.default.http[0], client!.transport),
      pollingInterval: 60_000,
    });

    const walletClient = createWalletClient({
      chain: client!.chain,
      transport: custom(provider as any),
    });

    // https://ethereum.stackexchange.com/questions/132850/incorrect-gaslimit-estimation-for-transaction
    const estimateGas = await publicClient.estimateContractGas({
      address: stake.ponziRule!.contract.address as AddressType,
      abi: ReceiveRewardABI,
      functionName: "receiveReward",
      args: [stake.externalId, values.withdrawDeposit, false],
      account: address!,
    });

    return await walletClient.writeContract({
      address: stake.ponziRule!.contract.address as AddressType,
      abi: ReceiveRewardABI,
      functionName: "receiveReward",
      args: [stake.externalId, values.withdrawDeposit, false],
      gas: (estimateGas * 110n) / 100n,
      account: address!,
    });
  });

  const handleReward = () => {
    // setIsRewardDialogOpen(true);
  };

  // const handleRewardConfirm = (values: IDepositRewardDto) => {
  //   return metaFn(stake, values);
  // };
  //
  // const handleRewardCancel = () => {
  //   setIsRewardDialogOpen(false);
  // };

  if (stake.ponziDepositStatus !== PonziDepositStatus.ACTIVE) {
    return null;
  }

  return (
    <Fragment>
      <ListAction
        onClick={handleReward}
        icon={Redeem}
        message="form.tips.reward"
        className={className}
        dataTestId="StakeRewardButton"
        disabled={disabled}
        variant={variant}
      />
      <DepositRewardDialog
        initialValues={{
          rule: stake.ponziRule!,
          withdrawDeposit: false,
          startTimeStamp: stake.startTimestamp,
        }}
      />
    </Fragment>
  );
};
